import { createFileRoute } from "@tanstack/react-router";
import { ComponentDetailPage } from "../../../components/products/ComponentDetailPage";
import { requireModuleAccess, MODULE_WORKSPACE } from "../../../lib/auth/route-protection";

export const Route = createFileRoute("/workspace/components/$componentId/")({
  beforeLoad: requireModuleAccess(MODULE_WORKSPACE),
  component: ComponentDetailRoute,
});

function ComponentDetailRoute() {
  const { componentId } = Route.useParams();
  return <ComponentDetailPage componentId={componentId} />;
}
